<app-confirm-dialog></app-confirm-dialog>
<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!-- START navbar header-->
    <div class="navbar-header">
        <a class="navbar-brand d-flex align-items-center" routerLink="/home">
            <div class="brand-logo custom-brlogo">
                <img class="img-fluid" src="assets/img/Logo- Horizontal.png" alt="App Logo" />
            </div>
            <div class="brand-logo-collapsed ">
                <img class="img-fluid" src="assets/img/180X180-Favicon_With Biometrics.png" alt="App Logo" />

            </div>

        </a>
    </div>
    <!-- END navbar header-->
    <!-- START Left navbar-->
    <ul class="navbar-nav mr-auto flex-row">
        <li class="nav-item">
            <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <a class="nav-link d-none d-md-block d-lg-block d-xl-block" trigger-resize=""
                (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
                <em class="fas fa-bars"></em>
            </a>
            <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
            <a class="nav-link sidebar-toggle d-md-none"
                (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
                <em class="fas fa-bars"></em>
            </a>
        </li>
        <!-- START User avatar toggle-->

        <!-- END User avatar toggle-->

    </ul>
    <!-- END Left navbar-->
    <!-- START Global Search -->
    <div class="navbar-nav flex-row align-items-center ps-gs-header-slot">
        <app-global-search class="w-100"></app-global-search>
    </div>
    <!-- END Global Search -->
    <!-- START Right Navbar-->
    <ul class="navbar-nav flex-row align-items-center ml-auto flex-nowrap">

        <li class="nav-item dropdown dropdown-list">
            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" (click)="openModal()">
                <em class="fas fa-users"></em>
            </a>
        </li>

        <app-live-notifications audience="admin"></app-live-notifications>

        <!-- START lock screen-->
        <li class="nav-item dropdown dropdown-list d-flex align-items-center userStart" dropdown>
            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle
                style="cursor: pointer;" role="button" aria-haspopup="true" aria-label="Account menu">
                <span class="user-name-badge">Welcome {{LoggedInUserFirstName}}</span>
            </a>
            <!-- START Dropdown menu-->
            <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated fadeIn ps-account-dropdown">
                <a class="dropdown-item" style="cursor: pointer;" (click)="navigateTo2StepAuth()">
                    <em class="fas fa-unlock"></em>
                    <span>Account Details</span>
                </a>
                <a class="dropdown-item" style="cursor: pointer;" (click)="adminLogout()">
                    <em class="fas fa-user-lock"></em>
                    <span>Logout</span>
                </a>
            </div>
            <!-- END Dropdown menu-->
        </li>
        <!-- END lock screen-->

        <!-- END Offsidebar menu-->
    </ul>
    <!-- END Right Navbar-->

    <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

</nav>
<!-- END Top Navbar-->

<div class="modal subscriber-switch-modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
    <div class="modal-dialog dialog325 modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content subscriber-switch-card">
            <div class="modal-header subscriber-switch-header">
                <div class="subscriber-switch-heading">
                    <!-- <span class="subscriber-switch-kicker">Advanced switcher</span> -->
                    <h4 class="modal-title subscriber-switch-kicker">Switch Subscriber</h4>
                </div>

                <button type="button" class="close subscriber-switch-close" aria-label="Close" data-dismiss="modal"
                    (click)="onCloseHandled()"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body subscriber-switch-body">
                <div class="subscriber-search-shell">
                    <div class="subscriber-search-input">
                        <em class="fas fa-search subscriber-search-icon"></em>
                        <input class="form-control subscriber-search-field" type="text" placeholder="Search subscribers"
                            [(ngModel)]="term" (focus)="onSearchFocus()" (blur)="onSearchBlur()"
                            (ngModelChange)="onSearchChange($event)" (keydown.enter)="rememberSearch(term)"
                            aria-label="Search subscribers" />
                        <button *ngIf="term" type="button" class="subscriber-search-clear" (click)="clearSearch()"
                            aria-label="Clear search">Clear</button>
                    </div>

                    <div class="subscriber-search-meta">
                        <span>{{ getVisibleSubscriberCount() }} matches</span>
                        <span *ngIf="recentSearches.length">{{ recentSearches.length }} recent searches saved</span>
                    </div>
                </div>

                <div class="subscriber-assist-panel" *ngIf="showSearchAssistPanel()">
                    <div class="assist-section" *ngIf="recentSearchMatches.length">
                        <div class="assist-section-header">
                            <span>Recent searches</span>
                            <button *ngIf="recentSearches.length" type="button" class="assist-link"
                                (click)="clearRecentSearches()">Clear all</button>
                        </div>
                        <div class="assist-chip-row">
                            <button type="button" class="assist-chip" *ngFor="let searchItem of recentSearchMatches"
                                (click)="selectRecentSearch(searchItem)">
                                <em class="far fa-clock"></em>
                                <span>{{ searchItem }}</span>
                            </button>
                        </div>
                    </div>


                </div>

                <div class="subscriber-results-shell">
                    <div class="subscriber-results-header">
                        <span>Subscribers</span>
                        <span class="subscriber-results-count">{{ getVisibleSubscriberCount() }}</span>
                    </div>

                    <ul class="subscriber-results-list">
                        <li *ngFor="let user of allUserData | filter:term" (click)="subscriberSwitch(user)"
                            class="subscriber-result-item">
                            <div class="subscriber-result-main">
                                <span class="subscriber-result-name">{{ user.companyName }}</span>
                                <span *ngIf="user.dvID" class="subscriber-result-tag">DV</span>
                            </div>
                            <!-- <small class="subscriber-result-note">Select to switch into this account</small> -->
                        </li>
                    </ul>

                    <div class="subscriber-empty-state" *ngIf="getVisibleSubscriberCount() === 0">
                        No subscribers match your search.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>